import { Icon, Icons } from 'components/Icon';
import React from 'react';
import { StockShare } from 'service/dto/stock-share.dto';
import Stocks from '../../../assets/assets/stocks.png';

type Props = {
  asset: StockShare;
  selectedAssetId?: number;
  handleShowDetails?: () => void;
};

export default function StockAsset({
  asset,
  selectedAssetId,
  handleShowDetails
}: Props) {
  return (
    <>
      <div className="border-b border-[#E5E5E5]">
        <div className="flex items-center justify-between p-3 px-5">
          <span className="text-base font-normal text-[#34475E]">
            Stocks/Shares
          </span>
          {handleShowDetails && (
            <button
              type="button"
              className={`cursor-pointer ${
                selectedAssetId === asset.id ? 'rotate-180' : ''
              }`}
              onClick={handleShowDetails}
            >
              <Icon name={Icons.ArrowDownCircle} />
            </button>
          )}
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between px-4 pb-1">
        <div className="mr-3 space-y-2">
          <img src={Stocks} className="h-[6.5rem] w-[6.5rem] object-contain" />
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Company Name
          </div>
          <div className="text-xs text-slate-600 ">{asset.companyName}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">CSCS Number</div>
          <div className="text-xs text-slate-600 ">{asset.certificateNo}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Stockbroker Name
          </div>
          <div className="text-xs text-slate-600 ">{asset.registerName}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Stockbroker Address
          </div>
          <div className="text-xs text-slate-600 ">{asset.registerAddress}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Percentage Alloted
          </div>
          <div className="text-xs text-slate-600 ">
            {asset.percentageAlloted}%
          </div>
        </div>
        {asset.totalBeneficiary ? (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Number of Beneficaries
            </div>
            <div className="text-xs text-slate-600 ">
              {asset.totalBeneficiary}
            </div>
          </div>
        ) : (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">Country</div>
            <div className="text-xs text-slate-600 ">
              {asset.country ?? 'N/A'}
            </div>
          </div>
        )}
        <div className="my-2 mr-3 space-y-2"></div>
      </div>
    </>
  );
}
